import { Component, Input } from '@angular/core';
import { Job } from '../../../../../../shared/models/models';

@Component({
	selector: 'invoice-job-info',
	template: require('./invoice-job-info.html'),
	styles: [require('./invoice-job-info.scss')]
})
export class InvoiceJobInfoComponent {
	@Input() job: Job;

	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/invoices/invoice-update/invoice-job-info/invoice-job-info.ts